<template>
  <div class="w-100">
    <div 
      class="w-100 d-flex align-items-start mb-4"
      v-for="(product,product_i) in products">
      <div class="addt-serv-qty radius-6 border-form bg-grey-dark mr-3">
        <p class="text-14 text-center font-lato mb-0">{{ product.qty }}x</p>
      </div>
      <div class="w-100">
        <p class="mb-0 body-2-4">{{ product.name }}</p>
        <p class="mb-0 text-12 font-lato text-orange">{{ $formatCurrency(product.price) }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['data'],
    computed:{
      products(){
        let all_product = []

        let assignProduct = (name,variant_name,qty,price) => {
          all_product.push({
            qty: qty,
            name: this.$isNotEmpty(variant_name) ? `${variant_name} - ${name}` : name,
            price: price
          })
        }
        
        this.data.additional_service_details.forEach(original => {
          let {name,variant_name,qty,price} = original
          let total_price = price*qty
          assignProduct(name,variant_name,qty,total_price)
        });

        this.data.tx_merchant_pos.forEach(merchant_pos=>{
          merchant_pos.products.forEach(product=>{
            let {name,variant_name,qty,subtotal_sell} = product
            assignProduct(name,variant_name,qty,subtotal_sell)
          })
        })
      
        return all_product
      }
    }
  }
</script>
<style>
.addt-serv-qty{
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  text-align: center;
  flex-shrink: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/hotel/be/additionalService/ProductBookingResult.vue